import MyMenu from './menu.vue';

MyMenu.install = function(Vue){
  Vue.component('MyMenu', MyMenu);
};

export default MyMenu;